var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "20.023",
        viewBox: "0 0 20.023 20.023",
        width: "20.023",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          id: "word",
          d: "M0,10.012A10.011,10.011,0,1,0,10.011,0,10.023,10.023,0,0,0,0,10.012ZM10.011,2.749a7.26,7.26,0,0,1,6.013,11.332L5.942,4a7.222,7.222,0,0,1,4.069-1.251Zm4.069,13.276A7.26,7.26,0,0,1,4,5.942Z",
          fill: "#afafaf",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }